const GET_ACQUISITION_CODE_MAINTENANCE_GRID_DATA = 'GET_ACQUISITION_CODE_MAINTENANCE_GRID_DATA';
const SET_ACQUISITION_CODE_MAINTENANCE_GRID_DATA = 'SET_ACQUISITION_CODE_MAINTENANCE_GRID_DATA';

const GET_UPDATED_BY_ACQUISITION_LIST = 'GET_UPDATED_BY_ACQUISITION_LIST';
const SET_UPDATED_BY_ACQUISITION_LIST = 'SET_UPDATED_BY_ACQUISITION_LIST';

const SAVE_DISCOUNT_FLAG = 'SAVE_DISCOUNT_FLAG';
const SET_DISCOUNT_FLAG = 'SET_DISCOUNT_FLAG';

const GET_ACQUISITION_CODE_MAINTENANCE_EXCEL_DATA = 'GET_ACQUISITION_CODE_MAINTENANCE_EXCEL_DATA';
const SET_ACQUISITION_CODE_MAINTENANCE_EXCEL_DATA = 'SET_ACQUISITION_CODE_MAINTENANCE_EXCEL_DATA';


export {
    GET_ACQUISITION_CODE_MAINTENANCE_GRID_DATA,
    SET_ACQUISITION_CODE_MAINTENANCE_GRID_DATA,
    GET_UPDATED_BY_ACQUISITION_LIST,
    SET_UPDATED_BY_ACQUISITION_LIST,
    SAVE_DISCOUNT_FLAG,
    SET_DISCOUNT_FLAG,
    GET_ACQUISITION_CODE_MAINTENANCE_EXCEL_DATA,
    SET_ACQUISITION_CODE_MAINTENANCE_EXCEL_DATA
};
